import React from 'react';
import PropTypes from 'prop-types';
import { Button, Card, CardContent, Grid, Stack, Typography } from '@mui/material';
import Loading from '../../../components/loading';
import ErrorMessage from '../../../components/errorMessage';
import ExpenseGoalsModal from '../goals/ExpenseGoalsModal';
import { GoalProgressItem } from '../goals/GoalProgressItem';
import { GoalsEmptyState } from '../goals/GoalsEmptyState';
import { useGoalsTabScreen } from '../hooks/useGoalsTabScreen';
import { formatCurrency } from '../hooks/useGoalsVsActual';

export function GoalsTabWeb({ period }) {
  const {
    comparison,
    totalIncomes,
    hasGoals,
    isLoading,
    showErrorMessage,
    setShowErrorMessage,
    errorMessage,
    isGoalsModalOpen,
    openGoalsModal,
    closeGoalsModal,
    handleGoalsSaved,
  } = useGoalsTabScreen(period);

  return (
    <Card sx={{ position: 'relative' }}>
      <Loading isToHidden={isLoading === false} />

      {showErrorMessage && (
        <ErrorMessage
          message={errorMessage}
          show={showErrorMessage}
          setShow={setShowErrorMessage}
        />
      )}

      <CardContent>
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
          <Typography variant="subtitle2" color="text.secondary">
            Receita do período: {formatCurrency(totalIncomes)}
          </Typography>

          <Button variant="outlined" onClick={openGoalsModal}>
            Definir metas
          </Button>
        </Stack>

        {hasGoals === false && isLoading === false ? (
          <GoalsEmptyState onDefineGoals={openGoalsModal} />
        ) : (
          <Grid container spacing={3}>
            {comparison.map((goal) => (
              <Grid key={goal.categoryId} size={{ xs: 12, md: 6 }}>
                <GoalProgressItem goal={goal} />
              </Grid>
            ))}
          </Grid>
        )}
      </CardContent>

      <ExpenseGoalsModal
        open={isGoalsModalOpen}
        onClose={closeGoalsModal}
        onSaveSuccess={handleGoalsSaved}
      />
    </Card>
  );
}

GoalsTabWeb.propTypes = {
  period: PropTypes.shape({
    selectedDate: PropTypes.object.isRequired,
    viewByYear: PropTypes.bool.isRequired,
    viewAllPeriod: PropTypes.bool.isRequired,
  }).isRequired,
};
